var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBadgeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_1400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9907 8.09529L8 9.88863L5.00933 8.09529C4.9082 8.03469 4.79281 8.002 4.67492 8.00054C4.55703 7.99908 4.44086 8.02891 4.33826 8.08699C4.23566 8.14506 4.1503 8.22931 4.09087 8.33114C4.03145 8.43297 4.00009 8.54873 4 8.66663V11.3333C4.00009 11.4484 4.02998 11.5615 4.08676 11.6616C4.14354 11.7618 4.22527 11.8455 4.324 11.9046L7.65733 13.9046C7.76087 13.9667 7.8793 13.9994 8 13.9994C8.1207 13.9994 8.23913 13.9667 8.34267 13.9046L11.676 11.9046C11.7747 11.8455 11.8565 11.7618 11.9132 11.6616C11.97 11.5615 11.9999 11.4484 12 11.3333V8.66663C11.9999 8.54873 11.9685 8.43297 11.9091 8.33114C11.8497 8.22931 11.7643 8.14506 11.6617 8.08699C11.5591 8.02891 11.443 7.99908 11.3251 8.00054C11.2072 8.002 11.0918 8.03469 10.9907 8.09529Z",
    fill: "#6B758B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9907 2.09529L8 3.88863L5.00933 2.09529C4.9082 2.0347 4.79281 2.002 4.67492 2.00054C4.55703 1.99908 4.44086 2.02891 4.33826 2.08699C4.23566 2.14506 4.1503 2.22931 4.09087 2.33114C4.03145 2.43297 4.00009 2.54873 4 2.66663V5.33329C4.00009 5.44839 4.02998 5.56151 4.08676 5.66163C4.14354 5.76175 4.22527 5.84547 4.324 5.90463L7.65733 7.90463C7.76087 7.96667 7.8793 7.99943 8 7.99943C8.1207 7.99943 8.23913 7.96667 8.34267 7.90463L11.676 5.90463C11.7747 5.84547 11.8565 5.76175 11.9132 5.66163C11.97 5.56151 11.9999 5.44839 12 5.33329V2.66663C11.9999 2.54873 11.9685 2.43297 11.9091 2.33114C11.8497 2.22931 11.7643 2.14506 11.6617 2.08699C11.5591 2.02891 11.443 1.99908 11.3251 2.00054C11.2072 2.002 11.0918 2.0347 10.9907 2.09529Z",
    fill: "#6B758B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_1400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBadgeIcon);
export default __webpack_public_path__ + "static/media/chat-badge-icon.1964574661b8ac0c4a00492999f8a954.svg";
export { ForwardRef as ReactComponent };